<div
  class="drag-drop-overlay d-flex align-items-center justify-content-center"
  *ngIf="isActive"
  (dragover)="onOverlayDragOver($event)"
  (dragleave)="onOverlayDragLeave($event)"
  (drop)="onOverlayDrop($event)"
>
  <div class="drag-drop-overlay__content text-center">
    <div class="drag-drop-overlay__hint text-lg mb-2">
      <i class="cs-icon cs-icon-upload mr-2"></i>
      <span>{{ overlayText }}</span>
    </div>
    <div *ngIf="showProgress" class="drag-drop-overlay__progress d-flex align-items-center justify-content-center mb-2">
      <ngb-progressbar type="success" [value]="uploadProgress" [striped]="true" [animated]="true" class="w-100">
        <i i18n>Uploading</i>
      </ngb-progressbar>
    </div>
    <app-upload-box
      #uploadBox
      class="drag-drop-overlay__upload-box"
      [class.d-none]="!showUploadBox"
      direction="v"
      [options]="uploadOptions"
      [showFileList]="showFileList"
      (complete)="onUploadComplete($event)"
      (afterFileError)="onUploadError()"
      (addingFileFailed)="onUploadError()"
    ></app-upload-box>
  </div>
</div>
